import React, { useState } from "react";

import {
  VisibilityOffOutlined as VisibilityOffOutlinedIcon,
  VisibilityOutlined as VisibilityOutlinedIcon,
} from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material";

type Props = TextFieldProps & {
  ShowIcon?: React.ComponentType;
  HideIcon?: React.ComponentType;
};

const PasswordTextField = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      ShowIcon = VisibilityOutlinedIcon,
      HideIcon = VisibilityOffOutlinedIcon,
      ...textFieldProps
    },
    ref
  ) => {
    const [visible, setVisible] = useState(false);

    return (
      <TextField
        ref={ref}
        {...textFieldProps}
        type={visible ? "text" : "password"}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                tabIndex={-1}
                onClick={() => setVisible((prev) => !prev)}
              >
                {visible ? <HideIcon /> : <ShowIcon />}
              </IconButton>
            </InputAdornment>
          ),
          ...textFieldProps.InputProps,
        }}
      />
    );
  }
);

export default PasswordTextField;
